import { useClientHasRendered } from '../hooks';
import { useIsMobileDevice } from './useIsMobileDevice';

export const UNSUPPORTED_USER_AGENTS = [
  'Instagram',
  'FBAN',
  'FBAV',
  'FB_IAB',
  'FBAN/Messenger',
  'TikTok',
];

export const useIsUnsupportedInAppBrowser = (): boolean => {
  const clientHasRendered = useClientHasRendered();
  const isMobileDevice = useIsMobileDevice();
  const isUserComingFromUnsupportedApp =
    clientHasRendered &&
    isMobileDevice &&
    // Check if the user agent includes any of the unsupported user agents
    UNSUPPORTED_USER_AGENTS.some(agent => window.navigator.userAgent.includes(agent));

  return isUserComingFromUnsupportedApp;
};
